import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "tw-w-full tw-bg-white tw-rounded-md tw-shadow-sm tw-p-4 tw-flex tw-flex-col tw-gap-3",
  style: {"min-width":"min(40rem, calc(100vw - 4rem))"}
}
const _hoisted_2 = { class: "tw-flex tw-flex-col" }
const _hoisted_3 = { class: "tw-font-bold tw-text-lg tw-capitalize" }
const _hoisted_4 = { class: "tw-text-sm tw-text-gray-500" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { class: "tw-w-full" }, null, -1)
const _hoisted_6 = { class: "tw-flex tw-flex-col md:tw-flex-row tw-gap-4" }
const _hoisted_7 = { class: "tw-flex-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs tw-uppercase tw-text-gray-500" }, "Profesional", -1)
const _hoisted_9 = { class: "tw-font-medium" }
const _hoisted_10 = { class: "tw-flex-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs tw-uppercase tw-text-gray-500" }, "Especialidad", -1)
const _hoisted_12 = { class: "tw-font-medium" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs tw-uppercase tw-text-gray-500" }, "Prácticas realizadas", -1)
const _hoisted_15 = { class: "tw-pl-0 tw-mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-2 tw-h-2 tw-rounded-full tw-bg-green-500 tw-mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.nombre), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(new Date(_ctx.datos?.datos?.fecha).toLocaleDateString()), 1)
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.medico?.nombre || 'No especificado'), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.especialidad?.nombre || 'No especificado'), 1)
      ])
    ]),
    (_ctx.practicas && _ctx.practicas.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("ul", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practicas, (practica, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "tw-flex tw-items-center tw-mb-1"
              }, [
                _hoisted_16,
                _createElementVNode("span", null, _toDisplayString(practica.descripcion || practica.nombre || practica), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}